import React from 'react';
import { Link } from 'react-router-dom';
import { Calendar, Clock, ArrowRight } from 'lucide-react';
import blogPosts from '../data/blogs.json';

const Blog = () => {

  return (
    <div className="bg-[#111418]">
      {/* Hero Section */}
      <section className="relative py-20">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl md:text-5xl font-bold leading-tight tracking-tighter text-white mb-6">
            Blog & <span className="text-secondary">Insights</span>
          </h1>
          <p className="text-xl text-[#e0e6ee] max-w-3xl mx-auto leading-relaxed">
            Expert perspectives on AI implementation, strategy, and industry trends
          </p>
        </div>
      </section>

      {/* Blog Posts */}
      <section className="py-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-6xl mx-auto">
          {blogPosts.length === 0 ? (
            <div className="text-center py-12">
              <h2 className="text-2xl font-bold text-white mb-4">
                Coming Soon
              </h2>
              <p className="text-[#9dabb9]">
                We're working on creating valuable content for you. Check back soon!
              </p>
            </div>
          ) : (
            <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
              {blogPosts.map((post) => (
                <Link 
                  key={post.id} 
                  to={`/blog/${post.slug}`}
                  className="group cursor-pointer block"
                >
                  <div className="group relative overflow-hidden rounded-lg bg-[#1a1e24] transition-all duration-300 hover:shadow-2xl hover:shadow-secondary/20 h-full">
                    <div className="p-6">
                      <div className="flex items-center gap-4 mb-4 text-xs uppercase tracking-wider text-[#9dabb9]">
                        <span>{post.category}</span>
                        <div className="flex items-center gap-1">
                          <Clock className="h-3 w-3" />
                          <span>{post.readTime}</span>
                        </div>
                      </div>
                      
                      <h3 className="text-lg font-bold text-white mb-4 leading-relaxed">
                        {post.title}
                      </h3>
                      
                      <p className="text-[#9dabb9] text-sm leading-relaxed mb-4">
                        {post.excerpt}
                      </p>
                      
                      <div className="flex items-center justify-between">
                        <div className="flex items-center gap-1 text-xs text-[#9dabb9]">
                          <Calendar className="h-3 w-3" />
                          <span>{new Date(post.date).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}</span>
                        </div>
                        <ArrowRight className="h-4 w-4 text-secondary group-hover:text-cyan-400 transition-colors" />
                      </div>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
};

export default Blog;